import { useFeatureFlag } from "@/Hooks/useFeature";
import useIsSuperOpsConnected from "@/Hooks/useIsSuperOpsConnected";

const useSuperOpsCrudLockout = (): boolean => {
	const isSuperOpsConnected = useIsSuperOpsConnected();
	const isLockoutEnabled = useFeatureFlag("superops_client_item_lockout");
	return isSuperOpsConnected && isLockoutEnabled;
};

export default useSuperOpsCrudLockout;
